import { LoadablePaint } from '@confluence/loadable';

export const MacroRendererPageLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-MacroRendererPage" */ './MacroRendererPage'))
			.MacroRendererPage,
});
